import { ShareType } from '../components/common/Sharing/sharing_copy';
import { ShareOptions } from '../components/common/Sharing/utils';

export const messageTypes = {
  resizeFrame: 'tt-pd',
  sendPubkey: 'tt-pubkey',
  addShareToasts: 'tt-add-share-toasts',
  checkForBadgeToasts: 'tt-check-for-badge-toasts',
  iframeLoaded: 'tt-iframe-loaded',
  finishedRegistration: 'finished_registration',
  showLevelCelebration: 'tt-show-level-celebration'
} as const;

export type ResizeFrameMessage = {
  type: 'tt-pd';
  payload: {
    height: number;
    width?: number;
  };
};

export type SendPubkeyMessage = {
  type: 'tt-pubkey';
  payload: {
    pubkey: string;
  };
};

export type ShareToastMessage = {
  type: 'tt-add-share-toasts';
  shareType: ShareType;
  options: ShareOptions;
};

export type ShowLevelCelebrationMessage = {
  type: 'tt-show-level-celebration';
  level: number;
};

export type CheckForBadgeToastsMessage = {
  type: 'tt-check-for-badge-toasts';
};

export type IFrameLoadedMessage = {
  type: 'tt-iframe-loaded';
};

export type FinishedRegistrationMessage = {
  type: 'finished_registration';
};

type PostMessageOptions<T> = {
  payload: T;
  targetOrigin?: string;
  useTopmostWindow?: boolean;
};

export const RESIZE_FRAME = (
  dimensions: ResizeFrameMessage['payload']
): PostMessageOptions<ResizeFrameMessage> => ({
  payload: {
    type: 'tt-pd',
    payload: dimensions
  },
  targetOrigin: '*',
  useTopmostWindow: true
});

export const SEND_PUBKEY = (pubkey: string): PostMessageOptions<SendPubkeyMessage> => ({
  payload: {
    type: 'tt-pubkey',
    payload: {
      pubkey
    }
  },
  targetOrigin: '*',
  useTopmostWindow: true
});

export const ADD_SHARE_TOAST = (
  shareType: ShareType,
  options: ShareOptions
): PostMessageOptions<ShareToastMessage> => ({
  payload: {
    type: 'tt-add-share-toasts',
    shareType,
    options
  },
  targetOrigin: '*'
});

export const SHOW_LEVEL_CELEBRATION = (
  level: number
): PostMessageOptions<ShowLevelCelebrationMessage> => ({
  payload: {
    type: 'tt-show-level-celebration',
    level
  },
  targetOrigin: '*'
});

export const CHECK_FOR_BADGE_TOASTS: PostMessageOptions<CheckForBadgeToastsMessage> = {
  payload: {
    type: 'tt-check-for-badge-toasts'
  },
  targetOrigin: '*'
};

export const postWindowMessage = <T>(options: PostMessageOptions<T>): void => {
  const origin = options.targetOrigin || window.location.origin;
  const targetWindow = options.useTopmostWindow ? window.top : window;
  targetWindow.postMessage(options.payload, origin);
};
